
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Dashboard from './components/Dashboard';
import DipendenteList from './components/DipendenteList';
import NegozioList from './components/NegozioList';
import TurnoList from './components/TurnoList';
import QuantitaPersonaleList from './components/QuantitaPersonaleList';
import GenerazioneOrarioRouter from './components/GenerazioneOrarioRouter';
import OrarioDipendenteCompact from './components/OrarioDipendenteCompact';
import MioOrarioRouter from './components/MioOrarioRouter';
import OrarioDipendente from './components/OrarioDipendente';
import ControlloOrari from './components/ControlloOrari';
import GestioneCambiTurno from './components/GestioneCambiTurno';
import Login from './components/Login';
import CambioPasswd from './components/CambioPasswd';
import ProtectedRoute from './components/ProtectedRoute';
import AccessControl from './components/AccessControl';
import GdvOutboxLog from './components/GdvOutboxLog';
import OutboxAuditPage from './components/OutboxAuditPage';
import { SettingsProvider } from './context/SettingsContext';
import { useUserValidityCheck } from './hooks/useUserValidityCheck';
import RouteValidator from './components/RouteValidator';
import CoordinatoreOreLockGuard from './components/CoordinatoreOreLockGuard';
import TurnoNonConfermatoPopup from './components/TurnoNonConfermatoPopup';
import VersionUpdateGuard from './components/VersionUpdateGuard';

// Tema base Material-UI
const theme = createTheme();

const App: React.FC = () => {
  // Controlla 1 volta al giorno se l'utente esiste ancora in gestione_utenti
  useUserValidityCheck();
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <VersionUpdateGuard />
      <SettingsProvider>
        <Router>
          <RouteValidator />
          <CoordinatoreOreLockGuard />
          <TurnoNonConfermatoPopup />
          <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/cambio-password" element={<CambioPasswd />} />
          <Route path="/dashboard" element={
            <ProtectedRoute>
              <AccessControl>
                <Dashboard />
              </AccessControl>
            </ProtectedRoute>
          } />
          <Route path="/negozi" element={
            <ProtectedRoute>
              <AccessControl>
                <NegozioList />
              </AccessControl>
            </ProtectedRoute>
          } />
          <Route path="/dipendenti" element={
            <ProtectedRoute>
              <AccessControl>
                <DipendenteList />
              </AccessControl>
            </ProtectedRoute>
          } />
          <Route path="/turni" element={
            <ProtectedRoute>
              <AccessControl>
                <TurnoList />
              </AccessControl>
            </ProtectedRoute>
          } />
          <Route path="/quantita-personale" element={
            <ProtectedRoute>
              <AccessControl>
                <QuantitaPersonaleList />
              </AccessControl>
            </ProtectedRoute>
          } />
          <Route path="/generazione-orario" element={
            <ProtectedRoute>
              <AccessControl>
                <GenerazioneOrarioRouter />
              </AccessControl>
            </ProtectedRoute>
          } />
          <Route path="/mio-orario" element={
            <ProtectedRoute>
              <AccessControl>
                <MioOrarioRouter />
              </AccessControl>
            </ProtectedRoute>
          } />
          <Route path="/orario-dipendente" element={
            <ProtectedRoute>
              <AccessControl>
                <OrarioDipendente />
              </AccessControl>
            </ProtectedRoute>
          } />
          <Route path="/orario-dipendenti-taste" element={
            <ProtectedRoute>
              <AccessControl>
                <OrarioDipendente taste />
              </AccessControl>
            </ProtectedRoute>
          } />
          <Route path="/orario-dipendente-compatto" element={
            <ProtectedRoute>
              <AccessControl>
                <OrarioDipendenteCompact />
              </AccessControl>
            </ProtectedRoute>
          } />
          <Route path="/controllo-orari" element={
            <ProtectedRoute>
              <AccessControl>
                <ControlloOrari />
              </AccessControl>
            </ProtectedRoute>
          } />
          <Route path="/gestione-cambi-turno" element={
            <ProtectedRoute>
              <AccessControl>
                <GestioneCambiTurno />
              </AccessControl>
            </ProtectedRoute>
          } />
          <Route path="/mio-orario-coord" element={<Navigate to="/dashboard" replace />} />
          <Route path="/mio-orario-cord" element={<Navigate to="/dashboard" replace />} />
          {/* Pannello diagnostica outbox — solo Admin, non visibile in dashboard */}
          <Route path="/gdv-outbox-log" element={
            <ProtectedRoute>
              <AccessControl>
                <GdvOutboxLog />
              </AccessControl>
            </ProtectedRoute>
          } />
          {/* Audit demone outbox — solo Admin */}
          <Route path="/outbox-audit" element={
            <ProtectedRoute>
              <AccessControl>
                <OutboxAuditPage />
              </AccessControl>
            </ProtectedRoute>
          } />
          <Route path="/" element={<Navigate to="/dashboard" />} />
          </Routes>
        </Router>
      </SettingsProvider>
    </ThemeProvider>
  );
};

export default App;
